export const GOOD = 0;
export const REFUNDED = 1;
export const DELETED = 2;

export const DESCRIPTIONS = ['Good', 'Refunded', 'Deleted'];